import { Group, Table } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { BranchSelector } from '../../components/BranchSelector';
import { DataTable } from '../../components/DataTable';
import { PageHeader } from '../../components/PageHeader';
import { SearchField } from '../../components/SearchField';
import { Title } from '../../components/Title';
import { useFilter } from '../../hooks/useFilter';
import { usePagination } from '../../hooks/usePagination';
import { queryWithFilterPageAndSearch } from '../../util/api/queryWithFilterPageAndSearch';
import { CustomerRow } from './components/CustomerRow';
import type { CustomerDto } from './types/CustomerDto';
import { KeyedRow } from '../../components/KeyedRow';

export function Customers() {
	const { organisation } = useParams();
	const pagination = usePagination();
	const filter = useFilter();
	const [searchQuery, setSearchQuery] = useState('');

	const customersCountQuery = queryWithFilterPageAndSearch<number>(
		`${organisation}/customers/count`,
		filter.value,
		pagination.value,
		searchQuery,
	);

	const customersQuery = queryWithFilterPageAndSearch<CustomerDto[]>(
		`${organisation}/customers/all`,
		filter.value,
		pagination.value,
		searchQuery,
	);

	useEffect(() => {
		document.body.style.backgroundColor = 'white';
	}, []);

	return (
		<>
			<PageHeader title={'Customers'} hideFiltering>
				<Group>
					<SearchField
						placeholder={'Search name...'}
						onDelayComplete={(value) => setSearchQuery(value)}
					/>
					<BranchSelector filter={filter} />
				</Group>
			</PageHeader>
			<DataTable
				pagination={pagination}
				totalItems={customersCountQuery.data?.value}
				isRowsLoading={customersQuery.isLoading}
				isPaginationLoading={customersCountQuery.isLoading}
				rows={pagination.value.pageSize}
			>
				<Table.Thead>
					<KeyedRow>
						<Table.Th>
							<Title label={'First Name'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Last Name'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Card No.'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Phone No.'} />
						</Table.Th>
						<Table.Th w={'15vw'}>
							<Title label={'Email'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Branch'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Total Purchases'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Join Date'} />
						</Table.Th>
						<Table.Th>
							<Title label={'End Date'} />
						</Table.Th>
						<Table.Th>
							<Title label={'View'} />
						</Table.Th>
					</KeyedRow>
				</Table.Thead>
				<Table.Tbody>
					{customersQuery.data?.value.map((customer) => (
						<CustomerRow key={customer.id} customer={customer} />
					))}
				</Table.Tbody>
			</DataTable>
		</>
	);
}
